<template>
  <div>
                      <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
                    <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                    <v-btn dark text @click="snackbar = false">Close</v-btn>
                </v-snackbar>
                <v-card class="box">
                            <v-row justify="center">
                                <a href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/EasyPariksha-Question-Bank-Import-Format.csv">
                                <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn " @click="loader = 'loading3'">
                                    <v-icon left dark>mdi-cloud-download</v-icon>
                                    Download import CSV format
                                </v-btn>
                            </a>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="12" lg="4" sm="12">
                                    <v-file-input dense accept=".csv" v-model="file" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000"> </v-file-input>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                        <v-btn @click="submitFile" :loading="output_load" class="button">
                                    Upload
                                    <v-icon right>mdi-cloud-upload</v-icon>
                                </v-btn>
                            </v-row>
                    </v-card>  
                    <v-app id="inspire">
                                    <!-- <v-data-table :item-class="itemRowBackground" :headers="headers2" :search="search1" :items="allData"  sort-by   :loading="output_load">
                        <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search1" label="Search" class="pt-4"></v-text-field>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    
                    
                    <v-text-field v-model="search1" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <template v-slot:item.Message="{ item }">
                        <p v-for="msg in item.msg" :key="msg">{{msg}}</p>
                    </template>
                </v-data-table> -->

                 <v-simple-table v-if="allData.length > 0">
                    <thead>
                        <tr style="background-color:hsla">
                            <th class="text-left">Unit</th>
                            <th class="text-left">Difficulty Level</th>
                            <th class="text-left">Question</th>
                            <th class="text-left">Option A</th>
                            <th class="text-left">Option B</th>
                            <th class="text-left">Option C</th>
                            <th class="text-left">Option D</th>
                            <th class="text-left">Option E</th>
                            <th class="text-left">Correct Option</th>
                            <th class="text-left">Message</th>

                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr v-for="(item) in allData" :key="item" :class="item.msg.length == 0 ? style-1:style-2"> -->
                        <tr v-for="(item) in allData" :key="item" :class="{'style-1':(item.msg.length !== 0)}">
                            <td v-if="item.unit">{{ item.unit }}</td><td v-else>-</td>
                            <td v-if="item.diff_level">{{ item.diff_level }}</td> <td v-else>-</td>
                            <td v-if="item.question">{{ item.question }}</td> <td v-else>-</td>
                            <td v-if="item.optionA">{{ item.optionA }}</td> <td v-else>-</td>
                            <td v-if="item.optionB">{{ item.optionB }}</td> <td v-else>-</td>
                            <td v-if="item.optionC">{{ item.optionC }}</td> <td v-else>-</td>
                            <td v-if="item.optionD">{{ item.optionD }}</td> <td v-else>-</td>
                            <td v-if="item.optionE">{{ item.optionE }}</td> <td v-else>-</td>
                            <td v-if="item.correct_option">{{ item.correct_option }}</td> <td v-else>-</td>
                            <template v-if="item.msg.length > 0">
                            <td  v-for="msgs in item.msg" :key="msgs"><p>
                                {{ msgs }}</p></td></template>
                            <template v-else><td><p>
                                {{ msgs }}</p></td></template>

                        </tr>
                    </tbody>
                </v-simple-table>
                    </v-app>
                    
                    
                    </div>
                    
</template>

<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
import Template from '../../COE/Template/Template.vue';

export default {
  components: { Template },

    data:()=>({
  file: null,
  allData:[],
          snackbar_msg: "",
        color: "",
        snackbar: false,
            courseinfo: null,
            loading3:false,
            question_list: null,
            unit_list: null,
            diff_level_list: null,
            output_load:false,
            qttype: null,
            qno: null,
            examtype:null,
            unitwisequestion:null,
            cssclass:true,
                headers2: [
                    // { text: "Sr No", value: "examdata.srno" },
                    { text: "Unit", value: "unit" },
                    { text: "Difficulty Level", value: "diff_level" },
                    { text: "Question", value: "question" },
                    { text: "Option A", value: "optionA" },
                    { text: "Option B", value: "optionB" },
                    { text: "Option C", value: "optionC" },
                    { text: "Option D", value: "optionD" },
                    { text: "Option E", value: "optionE" },
                    { text: "Correct Option", value: "correct_option" },
                    { text: "Message", value: "Message" },


                ],
                search1:''

    }),
    mounted(){
this.onLoad()
    },
methods:{
    itemRowBackground(item) {
        alert('in css changes')
    //  return item.msg.length == 0 ? 'style-1' : 'style-2'
      const rowClass = 'myclass'
        return rowClass;
  },
        onLoad(){
                const data = {
                crs_id: this.$store.getters.courseid,
                qtypeid: this.$store.getters.qbankquestype,
                questypeid: this.$store.getters.questype,
                mess: "test",
            };
            axios
                .post("/Qbank/addQuestion", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.courseinfo = res.data.crsinfo;
                        this.question_list = res.data.question_list;
                        this.unit_list = res.data.unitno;
                        this.diff_level_list = res.data.difficultylevel;
                        this.qttype = res.data.questionType;
                        this.qno = res.data.qno;
                        (this.examtype = res.data.examType), (this.unitwisequestion = res.data.unit_question);
                        // this.load = true;
                        // this.ext_flag = false
                        // this.ext_flag1 = false
                        // this.ext_flag2 = false
                        // this.ext_flag3 = false
                        // this.ext_flag4 = false
                        // this.ext_flag5 = false
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
            },
            submitFile() {
this.output_load = true
            if (this.file == null) {
                this.showSnackbar("#b71c1c", "Please select the file!");
                //alert("Please select the file!");
            } else {
                this.output_load = true;
                      let formData = new FormData();
                      formData.append("file", this.file);
                formData.append("current_course", this.courseinfo.crsid);
                 formData.append("qno", this.qno);
                formData.append("qtype", this.qttype.id);
                formData.append("weightage", this.weightage);
                this.dialog_send = true
                axios
                    .post("Qbank/saveQuestionBankImport", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        if (res.data.msg == "200") {
                            this.allData = res.data.allData
                            this.output_load = false
                            this.file = null
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                        this.output_load = false
                    });
                //     }
            }
        }, 
                showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
}
}
</script>

<style scoped>
.box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
    }
    .flex {
        display: flex;
        justify-content: space-between;
    }
    .downbtn {
    float: right;
}
.style-1 {
  background-color: rgb(231, 231, 169);
  color: red;

}
.style-2 {
  background-color:greenyellow;
  color: white;
}
.myclass {
  background-color: green;
}
</style>
